import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { post } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import showMessage from "$ACTIONS/messageUtil";
import MyPromotionList from "@/MyPromotionTabs/List";
import ClaimBonusModal from "./ClaimBonusModal";
import { bonusActions } from "$STORE/bonusSlice";
import useFetchAppliedHistory from "@/MyPromotionTabs/hooks/useFetchAppliedHistory";

const Claimable = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isBlocking, setIsBlocking] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const balanceInfo = useSelector((state) => state.balance.balanceInfo);
    const [claimablePromotions, setClaimablePromotions] = useState([]);
    const dispatch = useDispatch();

    const { promotions, loading } = useFetchAppliedHistory("claimable");

    useEffect(() => {
        setClaimablePromotions(promotions);
    }, [promotions]);

    const removePromotion = (playerBonusId) => {
        setClaimablePromotions((prev) => prev.filter((item) => item.playerBonusId !== playerBonusId));
    };

    const handleCardAction = async (item, actionType) => {
        if (actionType === "claim") {
            Pushgtagdata("Bonus", "Claim Bonus", "Bonus_C_ClaimBonus");

            setIsSubmitting(true);

            try {
                const res = await post(`${ApiPort.POSTBonusClaim}`, {
                    playerBonusId: item?.playerBonusId,
                });

                if (res?.result?.isClaimed) {
                    removePromotion(item?.playerBonusId); // 调用回调函数，移除成功 claim 的 item
                    setIsBlocking(
                        balanceInfo?.isWithdrawalContractBalanceBlocking
                    );
                    setIsModalVisible(true);
                } else if (res?.result?.message) {
                    showMessage("info", res?.result?.message, 80);
                }
            } catch (error) {
                showMessage("info", "โปรดลองอีกครั้งในภายหลัง", 80);
                console.error("Error claiming bonus:", error);
            } finally {
                setIsSubmitting(false);
            }
        }
    };

    const handleOpenLockedBalancePage = () => {
        Pushgtagdata(
            "Bonus",
            "Go to Locked Balance",
            "Bonus_ClaimBonusSuccess_C_LockedBalance"
        );
        dispatch(bonusActions.setLockedBalanceVisible(true));
        setIsModalVisible(false);
    };

    return (
        <>
            <MyPromotionList
                promotions={claimablePromotions}
                loading={loading || isSubmitting}
                type="claimable"
                onCardActionClick={handleCardAction}
                showTabs={false}
                showDatePicker={false}
            />
            {isModalVisible && (
                <ClaimBonusModal
                    visible={isModalVisible}
                    onClose={() => setIsModalVisible(false)}
                    onOpenLockedBalancePage={handleOpenLockedBalancePage}
                    isBlocking={isBlocking}
                />
            )}
        </>
    );
};

export default Claimable;
